<section class="page-main-section">
  <div class="main-grid-container" *ngIf="leadFormConfig">
    <div class="image-section">
      <div class="logo-container">
        <img [src]="leadFormConfig.organizationImage" alt="" class="logo">
      </div>
      <div class="description-container py-2">
        <p class="description" [innerHTML]="leadFormConfig.leadFormConfiguration.description"></p>
      </div>
      <div class="image-container pb-4">
        <div class="image" [style.background-image]="getImageUrl()"></div>
      </div>
      <div class="footer-container desktop-footer">
        <div class="footer-item">
          <ion-icon name="call"></ion-icon>
          <p class="text">{{leadFormConfig.leadFormConfiguration.phone.countryCode}} {{leadFormConfig.leadFormConfiguration.phone.phone}}</p>
        </div>
        <div class="footer-item">
          <ion-icon name="mail"></ion-icon>
        <p class="text">{{leadFormConfig.leadFormConfiguration.email}}</p>
        </div>
        <div class="footer-item" *ngIf="leadFormConfig?.leadFormConfiguration?.website">
          <ion-icon name="globe"></ion-icon>
          <p class="text">{{leadFormConfig.leadFormConfiguration.website}}</p>
        </div>
      </div>
    </div>

    <div class="form-section" style="background-image: url(assets/Images/right-section-bg.png);">
      <form class="form-container container" [formGroup]="leadForm">
        <p class="form-title">{{leadFormConfig.leadFormConfiguration.formTitle}}</p>
        <div class="row form-row">
          <div class="col-6" *ngIf="checkFormFieldEnabled('showFirstName')">
            <div class="input-container">
              <label for="" class="label">First Name*</label>
              <div [ngClass]="{ 'invalid-input': leadForm.get('firstName')?.invalid && leadForm.get('firstName')?.touched }">
                <input appRestrictSpecialChars appRestrictNumbers [appMaxLength]="50" type="text" class="input" placeholder="Enter First Name" formControlName="firstName">
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showLastName')">
            <div class="input-container">
              <label for="" class="label">Last Name</label>
              <div [ngClass]="{ 'invalid-input': leadForm.get('lastName')?.invalid && leadForm.get('lastName')?.touched }">
                <input appRestrictSpecialChars appRestrictNumbers [appMaxLength]="50" type="text" class="input" placeholder="Enter Last Name" formControlName="lastName">
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showPhoneNumber')">
            <div class="input-container">
              <label for="" class="label">Phone Number*</label>
              <div [ngClass]="{ 'invalid-input': leadForm.get('phoneNumber')?.invalid && leadForm.get('phoneNumber')?.touched }">
                <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showEmailId')">
            <div class="input-container">
              <label for="" class="label">Email Address</label>
              <div [ngClass]="{ 'invalid-input': leadForm.get('email')?.invalid && leadForm.get('email')?.touched }">
                <input type="email" class="input" placeholder="Enter Your Email" formControlName="email">
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showPreferredDestination')">
            <div class="input-container">
              <label for="" class="label">Preferred Destination</label>
              <div>
                <app-locations-autocomplete formControlName="destination"></app-locations-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showNumberOfTravellers')">
            <div class="input-container">
              <label for="" class="label">No Of Travelers</label>
              <div>
                <app-no-of-guests-input formControlName="noOfGuests" ></app-no-of-guests-input>
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showStartDate')">
            <div class="input-container">
              <label for="" class="label">Planned Start Date</label>
              <div>
                <app-date-picker [minDate]="today" formControlName="startDate"></app-date-picker>
              </div>
            </div>
          </div>
          <div class="col-6" *ngIf="checkFormFieldEnabled('showEndDate')">
            <div class="input-container">
              <label for="" class="label">Planned End Date</label>
              <div>
                <app-date-picker formControlName="endDate" [disabled]="!leadForm.get('startDate')?.value" [minDate]="leadForm.get('startDate')?.value"></app-date-picker>
              </div>
            </div>
          </div>
          <!-- SERVICE TYPES -->
          <div class="col-12" *ngIf="checkFormFieldEnabled('showServices')">
            <div class="input-container">
              <div class="d-flex justify-content-between align-items-center my-2">
                <label for="" class="label">Select Service Types*<span class="text-danger warning-message ms-2"
                    *ngIf="leadForm.get('travelServices')?.invalid && leadForm.get('travelServices')?.touched">Select at
                    least 1 service</span></label>

                <ion-button class="clear-service-btn" (click)="clearServices()"
                  [disabled]="leadForm.get('travelServices')?.value?.length === 0">Clear
                  Services</ion-button>
              </div>

              <div class="service-type-input">
                <app-travel-service-input formControlName="travelServices" [invalidInput]="leadForm.get('travelServices')?.invalid && leadForm.get('travelServices')?.touched"></app-travel-service-input>
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="checkFormFieldEnabled('showMessage')">
            <div class="input-container">
              <label for="" class="label">Message</label>
              <div>
                <textarea name="" class="input" id="" placeholder="Enter Your Message" formControlName="message"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="button-container mt-2">
          <ion-button class="filled-blue-btn" type="button" (click)="onSubmit()" [disabled]="leadForm.invalid">Submit</ion-button>
        </div>
      </form>
      <div class="footer-container mobile-footer">
        <div class="footer-item">
          <ion-icon name="call"></ion-icon>
          <p class="text">{{leadFormConfig.leadFormConfiguration.phone.countryCode}} {{leadFormConfig.leadFormConfiguration.phone.phone}}</p>
        </div>
        <div class="footer-item">
          <ion-icon name="mail"></ion-icon>
        <p class="text">{{leadFormConfig.leadFormConfiguration.email}}</p>
        </div>
        <div class="footer-item" *ngIf="leadFormConfig?.leadFormConfiguration?.website">
          <ion-icon name="globe"></ion-icon>
          <p class="text">{{leadFormConfig.leadFormConfiguration.website}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="success-message-container" *ngIf="showSuccessScreen">
    <div class="inner-container">
      <button class="close-btn" (click)="closeSuccessScreen()">x</button>
      <p class="title">Thank You For Choosing {{leadFormConfig.organizationName}}</p>
      <p class="sub-title">We Will Contact You Shortly.</p>
    </div>
  </div>

  <app-spinner *ngIf="showSpinner"></app-spinner>
</section>